/*
 * ********************************************************************
 *  GlobePayroll Confidential
 *
 *  COPYRIGHT ©2016 by GlobePayroll. All Rights Reserved.
 *
 *   NOTICE:  All information contained herein is, and remains the property of GlobePayroll.
 *   The intellectual and technical concepts contained herein are proprietary to GlobePayroll
 *   and may be covered by U.S. and Foreign Patents, patents in process, and are protected by
 *   trade secret or copyright law.
 *   Dissemination of this information or reproduction of this material is strictly forbidden
 *   unless prior written permission is obtained from GlobePayroll.
 *  ********************************************************************
 */

import {Variable} from '../../shared/workflow/workflow-v2.interface';

export interface Notification {
  id: number;
  links: any[];
  notificationBody: string;
  notificationBodyArgs: { [key: string]: number | string | boolean };
  notificationHeader: string;
  notificationHeaderArgs: { [key: string]: number | string };
  notificationType: string;
  effectiveDate: string;
  dueDate: string;
  status: string;
  read: boolean;
  imgSrc?: string;
  description?: string;
  wasProcessed: boolean;
  reply: string;
  sanitizedData?: NotificationSanitizedData;
}

export interface NotificationSanitizedData {
  icon: string;
  processedClass: string;
  replyTranslation: string;
  notificationDescription: string;
  isFallbackRecipient: boolean;
}

export interface LeaveAnswer {
  userNotificationId: number;
  managerFirstName: string;
  managerLastName: string;
  managerOutput: string;
  managerComment: string;
  workflowId: number;
  actionRepWorkflowId: number;
  issuerContractId: number;
  associatedWorkflowIds: string;
}

export interface LeaveAnswerWorkflowV2 {
  managerOutput: string;
  managerComment: string;
}

export interface Notifications {
  notifications: Notification[];
  total: number;
}

export interface SortType {
  sort: string;
  title: string;
  checked: boolean;
  desc: boolean;
}

export interface Unread {
  unreadUserNotificationsCount: number;
  userId: number;
}

export interface NotificationFromSocket<T> {
  id: number;
  notificationType: string;
  status: string;
  read: boolean;
  effectiveDate: string;
  dueDate: string;
  datas: { [key: string]: T };
}

export interface PayPeriodContractChange {
  payPeriodContractId: number;
  contractId: number;
  payPeriodContractChangeType: string;
}

export interface RecentNotification {
  id: string;
  type: InboxItemType;
  notificationType?: string;
  title: string;
  read: boolean;
  creationDate: string;
  dueDate?: string;
  status?: string;
  variables?: Variable[];
  icon?: string;
}

export enum InboxItemType {
  TASK = 'TASK',
  NOTIFICATION = 'NOTIFICATION'
}

export enum NotificationType {
  CALCULATION = 'CALCULATION',
  COMMUNICATION = 'COMMUNICATION',
  BUSINESS_PROCESS = 'BUSINESS_PROCESS',
  STATUS_UPDATE = 'STATUS-UPDATE',
  PPC_CHANGE = 'PPC_CHANGE',
  MASS_ACTION = 'MASS_ACTION',
  ASYNC_PROCESS = 'ASYNC_PROCESS',
  REGULATION_EXPORT = 'REGULATION_EXPORT',
  REGULATION_DEPLOY = 'REGULATION_DEPLOY',
  REPORT_ANALYTICS = 'REPORT_ANALYTICS'
}



